import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    pesqNotas: ["payload"],
    pesqNotasSuces: ["payload"],
    removerNotaTabela: ["payload"],
    removerNotasTabela: ["payload"],
    onEditarTable: ["payload"],
    onEditarTableNovo: ["payload"],
    onExcluirTable: ["payload"],
    setSkip: ["payload"],
    setLoadSkipPesq: ["payload"],
    setLoadPesq: ["payload"],
    setFiltrosPesq: ["payload"],
    setMotoClientePesq: ["payload"],
    enviarEmail: ["payload"],
    buscarDest: ["payload"],
    buscarDestSucess: ["payload"],
    buscarTransp: ["payload"],
    buscarTranspSucess: ["payload"],
    limparTabela: ["payload"],
    replaceAllTabelaNotas: ["payload"],
});

const INITIAL_STATE = {
    filtros: {},
    loadPesq: false,
    loadSkipPesq: false,
    buttonDisabled: false,
    tabelaNotas: {
        dados: [],
    },
    notaSele: {},
    motoClientePesquisa: [],
    listaNotasEmail: [],
    listaNotasExcel: [],
    transp: [],
    dest: [],
};

const limparTabela = (state = INITIAL_STATE, action) => ({
    ...state,
    tabelaNotas: {
        dados: [],
    },
    filtros: {},
    loadPesq: false,
    loadSkipPesq: false,
});

const pesqNotasSuces = (state = INITIAL_STATE, action) => {
    const pesqDados = action.payload;

    let lista = Array.isArray(action.payload.dados) ? action.payload.dados : [];
    const dados = Array.isArray(action.payload.dados)
        ? action.payload.dados
        : [];
    let listaNotasEmail = [];
    let listaNotasExcel = [];

    for (let i in lista) {
        if (lista[i].historico) {
            if (lista[i].historico.length > 0) {
                for (let his in lista[i].historico) {
                    if (lista[i].historico[his].hasOwnProperty("cam_imagem")) {
                        listaNotasEmail.push({
                            label: lista[i].numero,
                            value: lista[i].historico[his].cam_imagem[
                                lista[i].historico[his].cam_imagem.length - 1
                            ],
                        });
                    }
                }
            }
        }
    }

    for (let i in lista) {
        listaNotasExcel.push({
            numero: lista[i].numero,
            serie: lista[i].serie,
            remetenteNome: lista[i].remetenteNome,
            remetenteCnpj: lista[i].remetenteCnpj,
            situacao: lista[i].situacaoNota,
            dataEmissao: lista[i].dataEmissao,
            dataComprovacao: lista[i].dataComprovacao,
            protocolo: lista[i].protocolo,
            nomeTransp: lista[i].nome_transp,
        });
    }
    return {
        ...state,
        tabelaNotas: {
            total: pesqDados.total,
            pesquisado: state.loadSkipPesq
                ? state.tabelaNotas.pesquisado + pesqDados.pesquisados
                : pesqDados.pesquisados,
            dados,
        },
        listaNotasEmail,
        listaNotasExcel,
    };
};

const removerNotaTabela = (state = INITIAL_STATE, action) => {
    const payloadData = action.payload;

    return {
        ...state,
        tabelaNotas: {
            total: --state.tabelaNotas.total,
            pesquisado: --state.tabelaNotas.pesquisado,
            dados: state.tabelaNotas.dados.filter(
                (el, index) => index !== payloadData
            ),
        },
    };
};
const removerNotasTabela = (state = INITIAL_STATE, action) => {
    const { lista } = action.payload;
    return {
        ...state,
        tabelaNotas: {
            total: state.tabelaNotas.total - lista.length,
            pesquisado: state.tabelaNotas.pesquisado - lista.length,
            dados: state.tabelaNotas.dados.filter(
                (item) => !lista.some((element) => element === item.ar)
            ),
        },
    };
};

const onEditarTable = (state = INITIAL_STATE, action) => {
    let payload = action.payload;
    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar_nota ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados: novasNotas,
        },
        notaSele: nota,
    };
};

const onEditarTableNovo = (state = INITIAL_STATE, action) => {
    const { nota, notas, substituir } = action.payload;

    let dados = [];

    const ar = notas;

    dados = state.tabelaNotas.dados.map((element) =>
        element.ar === ar ? { ...element, ...substituir } : element
    );
    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados,
        },
        notaSele: nota,
    };
};

const onExcluirTable = (state = INITIAL_STATE, action) => {
    let payload = action.payload;

    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar_nota ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            dados: novasNotas,
        },
        notaSele: nota,
    };
};

const setSkip = (state = INITIAL_STATE, action) => {
    const pesqDados = action.payload;

    const newDados = Array.isArray(action.payload.dados)
        ? action.payload.dados
        : [];
    const oldDados = state.tabelaNotas.dados;

    return {
        ...state,
        tabelaNotas: {
            pesquisado: state.loadSkipPesq
                ? state.tabelaNotas.pesquisado + pesqDados.pesquisados
                : pesqDados.pesquisados,
            total: pesqDados.total,
            dados: [...oldDados, ...newDados],
        },
    };
};

const setLoadSkipPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    loadSkipPesq: action.payload,
});

const replaceAllTabelaNotas = (state = INITIAL_STATE, action) => ({
    ...state,
    tabelaNotas: {
        ...state.tabelaNotas,
        dados: action.payload,
    },
});

const setLoadPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    loadPesq: action.payload,
});

const setFiltrosPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    filtros: action.payload,
});

const buscarDest = (state = INITIAL_STATE, action) => ({
    ...state,
    dest: action.payload,
});

const buscarTransp = (state = INITIAL_STATE, action) => ({
    ...state,
    transp: action.payload,
});

const setMotoClientePesq = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        motoClientePesquisa: action.payload,
    };
};

export default createReducer(INITIAL_STATE, {
    [Types.PESQ_NOTAS_SUCES]: pesqNotasSuces,
    [Types.REMOVER_NOTA_TABELA]: removerNotaTabela,
    [Types.REMOVER_NOTAS_TABELA]: removerNotasTabela,
    [Types.ON_EXCLUIR_TABLE]: onExcluirTable,
    [Types.ON_EDITAR_TABLE]: onEditarTable,
    [Types.ON_EDITAR_TABLE_NOVO]: onEditarTableNovo,
    [Types.SET_SKIP]: setSkip,
    [Types.SET_LOAD_SKIP_PESQ]: setLoadSkipPesq,
    [Types.SET_LOAD_PESQ]: setLoadPesq,
    [Types.SET_FILTROS_PESQ]: setFiltrosPesq,
    [Types.SET_MOTO_CLIENTE_PESQ]: setMotoClientePesq,
    [Types.BUSCAR_DEST_SUCESS]: buscarDest,
    [Types.BUSCAR_TRANSP_SUCESS]: buscarTransp,
    [Types.LIMPAR_TABELA]: limparTabela,
    [Types.REPLACE_ALL_TABELA_NOTAS]: replaceAllTabelaNotas
});
